{
  "major": 7,
  "minor": 5,
  "patch": 0,
  "build": 4,
  "notes": "",
  "date": ""
}
